import "./Banner.css";
import { useContext, useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Pagination, Autoplay } from "swiper/modules";

import Full_screen_modal from "../../common/full_screen_modal/Full_screen_modal";
import { Success_lottie } from "../../common/lotties/success_lottie/Success_lottie";
import Common_Btn from "../../common/common-btn/Common_Btn";

import { Context } from "../../../utils/context";
import { Banners } from "../../../utils/apis/homepage";
import { IDS } from "../../../utils/common";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faCircleChevronLeft,
  faCircleChevronRight,
} from "@fortawesome/free-solid-svg-icons";

function Banner() {
  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);

  const [banner, setBanner] = useState([]);
  const [showModal, setShowModal] = useState(false);

  // 👉 Swiper Ref
  const swiperRef = useRef(null);

  // 👉 Force re-render for disabling arrows
  const [, setUpdate] = useState(0);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  // 👉 Auto close modal
  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        setShowModal(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showModal]);

  // 👉 API Call
  const getBanner = async () => {
    const res = await Banners();
    if (res?.success) setBanner(res.data);
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <>
      <section className="home_banner">
        <div className="custom_container">
          <div className="swiper_holder">
            <Swiper
              modules={[Pagination, Autoplay]}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={() => setUpdate((prev) => prev + 1)}
              // pagination={{ clickable: true }}
              loop={false}
              // autoplay={{
              //   delay: 3000,
              //   disableOnInteraction: false,
              // }}
              className="bannerSwiper"
            >
              {banner?.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="banner_card_holder">
                    <div
                      className="banner_slide"
                      style={{
                        backgroundImage: `url(${IDS?.IMG_URL}${item?.image})`,
                      }}
                    >
                      <div className="banner_content">
                        <h1 className="banner_heading">
                          {item?.name}
                          <br />
                          {item?.sub_title}
                        </h1>

                        <p className="banner_text">
                          {htmlToReactParser.parse(item?.description)}
                        </p>
                      </div>
                    </div>

                    <div
                      className="banner_slide_img_holder"
                      style={{
                        backgroundImage: `url(${IDS?.IMG_URL}${item?.image})`,
                      }}
                    ></div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="slider_static_holder">
              {/* 👉 Custom Navigation */}
              <div className="navigation_holder">
                <FontAwesomeIcon
                  icon={faAngleLeft}
                  className={`arrow_icon ${
                    swiperRef.current?.isBeginning ? "disabled" : ""
                  }`}
                  onClick={() =>
                    swiperRef.current && swiperRef.current.slidePrev()
                  }
                />

                <FontAwesomeIcon
                  icon={faAngleRight}
                  className={`arrow_icon ${
                    swiperRef.current?.isEnd ? "disabled" : ""
                  }`}
                  onClick={() =>
                    swiperRef.current && swiperRef.current.slideNext()
                  }
                />
              </div>

              <Common_Btn
                onClick={() => navigate("/contact-us")}
                text={
                  <>
                    GET A FREE QUOTE <FontAwesomeIcon icon={faAngleRight} />
                  </>
                }
              />
            </div>
          </div>
        </div>
      </section>

      {/* Success Modal */}
      <Full_screen_modal show={showModal} lottie={<Success_lottie />} />
    </>
  );
}

export default Banner;
